import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpService } from './http/http.service';
import { BusinessType, InvoiceTemplate, PageControl } from '../interface';

@Injectable({
  providedIn: 'root'
})
export class MiscService {
  constructor(private _http: HttpService) { }

  public getBusinessTypes(): Promise<BusinessType[]> {
    return firstValueFrom(this._http.get('/BusinessTypes'));
  }

  public async getInvoiceTemplates(type:number): Promise<InvoiceTemplate[]> {
    return firstValueFrom(this._http.get('/InvoiceTemplates?type='+type));
  }

  public globalSearch(query: string): Promise<any> {
    return firstValueFrom(this._http.get(`/search?query=${query}`));
  }
  public getScreenControls(name:string):Promise<PageControl[]> {
    return firstValueFrom(this._http.get(`/configuration/PageControls?screenName=${name}`));
  }
}
